import { Box, Divider } from '@mui/material';
import { FC } from 'react';

import { mergeSx } from '@abg/kit-base';

import { useAnalyticsLoginFunnel } from '../../../../../shared/analytics/hooks';
import { useLoginJourneyContext } from '../../../LoginJourneyContext';

import AmazonLoginButton from './atom/AmazonLoginButton/AmazonLoginButton';
import { deviderStyles } from './amazon-login.styling';
import { AmazonLoginProps } from './types';

export const AmazonLogin: FC<AmazonLoginProps> = ({
  styleParts,
  deviderText,
  btnCaption,
}) => {
  const { amazonLoginJourney } = useLoginJourneyContext();
  const { isLoading, startLoginJourney } = amazonLoginJourney || {};

  const recordAnalyticsLoginFunnel = useAnalyticsLoginFunnel();

  const handleClick = async () => {
    recordAnalyticsLoginFunnel({
      method: 'Amazon',
      login_state: 'login',
      step_number: 1,
      step_description: 'Overview',
    });
    await startLoginJourney();
  };

  return (
    <>
      <Box
        data-testid="login-dialog-divider-text"
        sx={mergeSx(deviderStyles, (styleParts || {}).dividerText)}
      >
        <Divider>{deviderText}</Divider>
      </Box>

      <AmazonLoginButton
        disabled={isLoading}
        onClick={() => handleClick()}
        component="button"
        variant="outlined"
        data-testid="login-dialog-amazon-btn"
        buttonStyles={styleParts?.amazonBtn}
        btnCaption={btnCaption}
      />
    </>
  );
};
